<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasAnimal from "../../class/DadosDespesasAnimal.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";


export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#A7E4F2",
        "#32736C",
        "#D9B504",
        "#F2811D",
        "#BFBFBF",
        "#A63C76",
        "#128BA6",
        "#F279A6",
        "#590222",
        "#BF343F",
        "#A7E4F2"
      ],
      labels: [
        "Pastagens",
        "Manut. inst. e benf.",
        "Manut. máq. e equipam.",
        "Animais recria-engorda",
        "Suplementos",
        "Produtos veterinários",
        "Insem. artif./reprodução",
        "Combustíveis e lubrific.",
        "Mão de obra",
        "Serviços técnicos",
        "Impostos e taxas",
        "Despesas administrativas",
        "Outras despesas"
      ],
       dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          return (parseFloat(opts.w.config.series[opts.seriesIndex].toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            var valor = val
            if(typeof valor !== "undefined")
            {
              return (parseFloat(valor.toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
            }else 
              return valor
          } 
        }
      }
    },
    series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ''
  }),

 mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed:{
    preencherGrafico: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
        var animais = new DadosDespesasAnimal(dado.dadosDespesasAnimal);
        var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
        var instalacoes = new DadosRecursosInstalacoes(dado.dadosRecursosInstalacoes);
        var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);

        var biblioteca = [   
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), 
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasAnimais(animais),
            BibliotecaDeCalculos.DespesasServicos(servicos)
        
        ];
        
        return biblioteca;
      })
      .then(
        g => (
          (this.series[0] = g[2].despesasPastagens()),
          (this.series[1] = g[2].despesasInstalacoesBenfeitorias()),
          (this.series[2] = g[2].despesasMaquinasEquipamentos()),
          (this.series[3] = g[3].despesasAnimaisRecriaEngorda()),
          (this.series[4] = g[3].despesasSuplementacao()),
          (this.series[5] = g[3].despesasProdutosVeterinarios()),
          (this.series[6] = g[3].despesasInseminacaoArtificalReproducao()),
          (this.series[7] = g[4].despesasCombustiveisLubrificantes()),
          (this.series[8] = g[4].despesasMaoDeObra()),
          (this.series[9] = g[4].despesasServicosTecnicos()),
          (this.series[10] = g[4].despesasImpostosTaxas()),
          (this.series[11] = g[4].despesasAdministrativas()),
          (this.series[12] = g[4].despesasOutrasDespesas())
        )
      );
    }
  }
};
</script>
<style scoped>
</style>
